import React, { lazy, Suspense, useEffect, useMemo, useState, useTransition } from "react"
import { Box, Stack, Tabs, Tab, Typography, Slider, Select, MenuItem, Divider, Button, IconButton, TextField, Icon, Accordion, AccordionDetails, AccordionSummary, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, createStyles, Skeleton } from "@mui/material"

// Type
import type { SyntheticEvent } from "react"
import TabPanel from "@/components/common/TabPanel"
import { useAppDispatch, useAppSelector } from "@/hooks"
import { getDefaultOption } from "@/utils/common"
import { resetProductDetails } from "@/redux/reducers/categoryReducer"


function ProductDescription({ productDetailsData }: any) {
  const dispatch = useAppDispatch();
  const styles: any = createStyles({
    tableBody: {
      // border: '1px solid #ddd', // border around the table body
    },
    tableRow: {
      '&:nth-of-type(odd)': {
        backgroundColor: '#f2f2f2', // alternate row background color
      },
    },
    tableCell: {
      padding: '8px', // cell padding
      borderBottom: '1px solid #ddd', // bottom border for each cell
      wordWrap: 'break-word',
    },
  });
  const defaultTabValue = useMemo(() => {
    const defaultTabValue = getDefaultOption([
      { enabled: productDetailsData?.isProductDescriptionShow, value: 0 },
      { enabled: productDetailsData?.isAdditionalInformationShow, value: 1 },
      { enabled: productDetailsData?.isRatingReviewShow, value: 2 },
    ], 0);
    return defaultTabValue
  }, [productDetailsData]);
  const [tabValue, setTabValue] = useState<number>(defaultTabValue)

  const handleTabChange = (event: SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }
  useEffect(() => {
    return () => {
      dispatch(resetProductDetails())
    }
  }, [])

  const renderProductSpecification = (property: string, value: string) => {
    return (
      <Stack className="ProductSpecification">
        <Typography>{property}</Typography>
        <Typography className="Value">{value}</Typography>
      </Stack>
    )
  }
  return (
    <Stack className="TabsWrapper">
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        className="ProductDescriptionTabs"
        aria-label="Product description tabs"
      >
        {productDetailsData?.isProductDescriptionShow ? <Tab component="h2" label="Product Description" value={0} /> : null}
        {productDetailsData?.isAdditionalInformationShow ? <Tab component="h2" label="Specifications" value={1} /> : null}
        {productDetailsData?.isRatingReviewShow ? <Tab label="Rating & Reviews" value={2} /> : null}
      </Tabs>
      {productDetailsData?.isProductDescriptionShow ? <TabPanel value={tabValue} index={0}>
        <Box className="ScrollbarWrapper">
          <Box className="Content ScrollbarBlue" dangerouslySetInnerHTML={{
            __html: productDetailsData?.fullDescription?.replace("<h1>&nbsp;</h1>", ""),
          }}>
          </Box>
        </Box>
      </TabPanel> : null}
      {productDetailsData?.isAdditionalInformationShow ? <TabPanel className="AdditionalInformation" value={tabValue} index={1}>
        <Box className="ScrollbarWrapper">
          <Box className="Content ScrollbarBlue">
            <Box className="Wrapper">
              {Object.entries(productDetailsData?.specifications)?.map((bulkProduct: any, index) => (
                renderProductSpecification(bulkProduct[0], bulkProduct[1])
              ))}
            </Box>
          </Box>
        </Box>
      </TabPanel> : null}
      {productDetailsData?.isRatingReviewShow ? <TabPanel value={tabValue} index={2}>
        <Box className="ScrollbarWrapper">
          <Box className="Content ScrollbarBlue">
          </Box>
        </Box>
      </TabPanel> : null}
    </Stack>
  )
}

export default ProductDescription